const CuentaSelected = {
    set: function (data) {
        sessionStorage.removeItem('cuenta');
        sessionStorage.setItem('cuenta', JSON.stringify(data));
    },
    get: function () {
        const data = sessionStorage.getItem('cuenta');
        return JSON.parse(data);
    },
};

export default CuentaSelected